import { FancyInput } from 'components/ui/Inputs';
import React from 'react';
import { setRequester } from 'redux/services/twittlebugs/sparingParams';
import { useAppDispatch } from 'redux/store';
import { useDebouncedCallback } from 'use-debounce';

export const RequesterFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();

  /* ******************** Functions ******************** */
  const handleChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    dispatch(setRequester(value || undefined));
  }, 500);

  return <FancyInput placeholder="Requester Name" onChange={handleChange} allowClear />;
};
